// Complete Mobile Product Card Hover Solution
// Add this to your theme's main JavaScript file or create a new file like 'mobile-hover.js'

document.addEventListener('DOMContentLoaded', function() {
  console.log('Mobile hover script loaded'); // For debugging
  
  // Find all product cards with hover images
  const productCards = document.querySelectorAll('.card--product .card__media.has-hover-image');
  
  console.log('Found product cards:', productCards.length); // For debugging
  
  productCards.forEach((card, index) => {
    const mainImage = card.querySelector('.card__main-image');
    const hoverImage = card.querySelector('.card__hover-image');
    const productLink = card.querySelector('a.js-prod-link');
    
    console.log(`Card ${index}:`, { mainImage: !!mainImage, hoverImage: !!hoverImage }); // For debugging
    
    if (!mainImage || !hoverImage) return;
    
    let isTouching = false;
    let touchStartTime = 0;
    let preventClick = false;
    
    // Force initial state
    resetImages();
    
    // Touch Start - Show hover image immediately
    card.addEventListener('touchstart', function(e) {
      console.log('Touch start on card', index); // For debugging
      
      isTouching = true;
      touchStartTime = Date.now();
      preventClick = false;
      
      // Show hover image with force
      showHoverImage();
      
      // Add class for CSS targeting
      card.classList.add('mobile-touching');
      
    }, { passive: false });
    
    // Touch Move - Keep hover image visible
    card.addEventListener('touchmove', function(e) {
      if (isTouching) {
        console.log('Touch move on card', index); // For debugging
        showHoverImage();
        preventClick = true; // Prevent click if user is scrolling
      }
    }, { passive: true });
    
    // Touch End - Handle click or hide hover
    card.addEventListener('touchend', function(e) {
      console.log('Touch end on card', index); // For debugging
      
      const touchDuration = Date.now() - touchStartTime;
      
      // Remove touching class
      card.classList.remove('mobile-touching');
      
      if (isTouching) {
        // If it was a very quick tap and no movement, allow click
        if (touchDuration < 300 && !preventClick) {
          // Quick tap - hide hover and allow navigation
          setTimeout(() => {
            resetImages();
          }, 100);
        } else {
          // Longer touch or movement - show hover for a moment then hide
          setTimeout(() => {
            resetImages();
          }, 800);
          
          // Prevent the click from navigating
          if (preventClick && productLink) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }
      
      isTouching = false;
    }, { passive: false });
    
    // Touch Cancel - Reset immediately
    card.addEventListener('touchcancel', function(e) {
      console.log('Touch cancel on card', index); // For debugging
      
      isTouching = false;
      preventClick = false;
      card.classList.remove('mobile-touching');
      resetImages();
    }, { passive: true });
    
    // Desktop Mouse Events (only for non-touch devices)
    if (!('ontouchstart' in window) || !navigator.maxTouchPoints) {
      card.addEventListener('mouseenter', function() {
        console.log('Mouse enter on card', index); // For debugging
        showHoverImage();
      });
      
      card.addEventListener('mouseleave', function() {
        console.log('Mouse leave on card', index); // For debugging
        resetImages();
      });
    }
    
    // Prevent unwanted clicks on mobile
    if (productLink) {
      productLink.addEventListener('click', function(e) {
        if (preventClick || (isTouching && (Date.now() - touchStartTime) > 300)) {
          console.log('Preventing click on card', index); // For debugging
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }, { capture: true });
    }
    
    // Helper functions
    function showHoverImage() {
      if (mainImage && hoverImage) {
        mainImage.style.setProperty('opacity', '0', 'important');
        hoverImage.style.setProperty('opacity', '1', 'important');
        hoverImage.style.setProperty('z-index', '10', 'important');
        card.classList.add('showing-hover');
      }
    }
    
    function resetImages() {
      if (mainImage && hoverImage) {
        mainImage.style.setProperty('opacity', '1', 'important');
        hoverImage.style.setProperty('opacity', '0', 'important');
        hoverImage.style.setProperty('z-index', '1', 'important');
        card.classList.remove('showing-hover');
      }
    }
  });
  
  // Additional mobile detection and setup
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
           ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0);
  }
  
  if (isMobileDevice()) {
    document.body.classList.add('mobile-device');
    console.log('Mobile device detected'); // For debugging
  }
});

// Fallback for older browsers or if DOMContentLoaded already fired
if (document.readyState === 'loading') {
  // Script loaded before DOM is ready
} else {
  // DOM is already ready, execute immediately
  console.log('DOM already loaded, executing mobile hover script');
}